// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import { WhiteText, GreyLightText } from "../../../global/uis/scss";

type ExpiresColorLabelPropsType = {
  status: number,
  classes: { [key: string]: string }
};

const styles = theme => ({
  root: {
    paddingRight: "32px",
  },
  badge: {
    top: "50%",
  },
  grey: {
    color: WhiteText,
    backgroundColor: GreyLightText,
  }
});

class AuthorisedLabel extends Component<*, ExpiresColorLabelPropsType> {

  render(): * {
    const status = this.props.status;
    const classes = this.props.classes;
    if (status === 1) {
      return (
        <Badge 
          color="primary"
          badgeContent={"\u2714"}
          classes={{ badge: classes.badge, root: classes.root }}>
          <Typography variant="subtitle1">Authorised Reseller</Typography>
        </Badge>
      );
    }
    else if (status === 0) {
      return (
        <Badge 
          color="secondary"
          badgeContent={"\u2573"} 
          classes={{ badge: classes.badge, root: classes.root }}>
          <Typography variant="subtitle1">Authorised Reseller</Typography>
        </Badge>
      );
    }
    else {
      return (
        <Badge 
          color="default"
          badgeContent={"\u002F"}
          classes={{ badge: classNames(classes.badge, classes.grey), root: classes.root }}>
          <Typography variant="subtitle1">Standard Reseller</Typography>
        </Badge>
      );
    }
  };
}

export default withStyles(styles)(AuthorisedLabel);
